import React from "react";
import { Box } from "@twilio-paste/core/box";
import { ChatIcon } from "@twilio-paste/icons/esm/ChatIcon";
import { ChevronDownIcon } from "@twilio-paste/icons/esm/ChevronDownIcon";
import { Text, TextStyleProps } from "@twilio-paste/core";
import { useDispatch, useSelector } from "react-redux";

import { changeExpandedStatus } from "../store/actions/genericActions";
import { AppState } from "../store/definitions";
import { containerStyles } from "./styles/EntryPoint.styles";

const titleStyles: TextStyleProps = {
    color: "colorTextWeakest",
    paddingLeft: "space30"
};
const EntryPointComponent = ({ children }: { children?: React.ReactNode }) => <>{children}</>;
const getEntryPointComponent = (componentProps: { [key: string]: any } = {}) => {
    let ChatIconComponent = () => <ChatIcon decorative={false} title="Open chat" size="sizeIcon60" />;

    if (componentProps?.EntryPoint?.imageUrl) {
        ChatIconComponent = () => (
            <Box as="image" element="ENTRY_POINT_IMAGE">
                <img src={componentProps?.EntryPoint?.imageUrl} alt="chat icon" />
            </Box>
        );
    }
    if (componentProps?.EntryPoint?.text) {
        return (
            <EntryPointComponent aria-hidden>
                <Text as="h2" {...titleStyles}>
                    {componentProps.EntryPoint.text}
                </Text>
                <ChatIconComponent />
            </EntryPointComponent>
        );
    }
    return (
        <EntryPointComponent>
            <ChatIconComponent />
        </EntryPointComponent>
    );
};
export const EntryPoint = () => {
    const dispatch = useDispatch();
    const { expanded, componentProps } = useSelector((state: AppState) => ({
        expanded: state.session.expanded,
        componentProps: state.config.componentProps
    }));
    return (
        <Box
            as="button"
            data-test="entry-point-button"
            onClick={() => dispatch(changeExpandedStatus({ expanded: !expanded }))}
            {...containerStyles}
            element="ENTRY_POINT"
            // eslint-disable-next-line
            tabIndex={1}
            aria-label={expanded ? "" : componentProps?.EntryPoint.text || "Open chat"}
        >
            {expanded ? (
                <ChevronDownIcon decorative={false} title="Minimize chat" size="sizeIcon80" />
            ) : (
                getEntryPointComponent(componentProps)
            )}
        </Box>
    );
};
